import lodash from 'lodash'

export const maxModuleLines = 100000

const imeiPattern = /^[A-Za-z0-9]{6,50}$/

/**
 * @param {string} inputText
 * @param {{ mode?: 'import' | 'imei' }} options
 *   - import: 入库，每行 IMEI 必填；可选 IMEI|SN|箱号|盘号，其余字段可留空
 *   - imei: 划拨/查询，每行仅 IMEI
 */
export function analyzeModules(inputText, options = {}) {
  const mode = options.mode === 'import' ? 'import' : 'imei'
  const rawLines = lodash.split(inputText, /\r*\n/)
  const totalLines = rawLines.length

  if (totalLines > maxModuleLines) {
    return { lines: totalLines, validModules: [], errorText: '' }
  }

  const validModules = []
  let errorText = ''

  lodash(rawLines).forEach(function(value) {
    value = lodash.trim(value)
    if (!value) {
      return
    }

    if (mode === 'import') {
      const parts = value.split('|')
      const imei = lodash.trim(parts[0])
      const sn = parts.length > 1 ? lodash.trim(parts[1]) : ''
      const boxNumber = parts.length > 2 ? lodash.trim(parts[2]) : ''
      const reelNumber = parts.length > 3 ? lodash.trim(parts[3]) : ''

      if (!imei) {
        errorText += `${value}（IMEI不能为空）\n`
        return
      }
      if (!imeiPattern.test(imei)) {
        errorText += `${value}（IMEI格式错误）\n`
        return
      }

      validModules.push({
        imei,
        sn,
        box_number: boxNumber,
        reel_number: reelNumber
      })
      return
    }

    const imei = lodash.trim(value.split('|')[0])
    if (!imei) {
      errorText += `${value}（IMEI不能为空）\n`
      return
    }
    if (!imeiPattern.test(imei)) {
      errorText += `${value}（IMEI格式错误）\n`
      return
    }

    validModules.push({
      imei,
      sn: '',
      box_number: '',
      reel_number: ''
    })
  })

  return { lines: totalLines, validModules, errorText }
}

export function formatModuleInputValue(modules, mode = 'imei') {
  if (!Array.isArray(modules) || modules.length === 0) {
    return ''
  }

  if (mode === 'import') {
    return modules.map((item) => {
      if (!item.sn && !item.box_number && !item.reel_number) {
        return item.imei
      }
      return [item.imei, item.sn || '', item.box_number || '', item.reel_number || ''].join('|')
    }).join('\n')
  }

  return modules.map((item) => item.imei).join('\n')
}
